// atproto plugin frontend: RSVP login reveal, share, event tabs, wall login.
// All handlers are delegated to the document because event content is
// injected via innerHTML (js/fetch.js) — inline scripts there never execute.

document.addEventListener('click', function (e) {
  // reveal login form when a logged-out visitor taps an RSVP chip
  var rsvpLogin = e.target.closest('[data-rsvp-login]');
  if (rsvpLogin) {
    var actions = rsvpLogin.closest('[data-event-actions]');
    var form = actions && actions.querySelector('[data-rsvp-login-form]');
    if (form) {
      form.hidden = false;
      var input = form.querySelector('input[name="handle"]');
      if (input) input.focus();
    }
    return;
  }

  // reveal login form on the wall compose box
  var wallLogin = e.target.closest('[data-wall-login]');
  if (wallLogin) {
    var wall = wallLogin.closest('.event-wall');
    var loginForm = wall && wall.querySelector('[data-wall-login-form]');
    if (loginForm) {
      loginForm.hidden = false;
      var handleInput = loginForm.querySelector('input[name="handle"]');
      if (handleInput) handleInput.focus();
    }
    return;
  }

  // share: native sheet where available, clipboard otherwise
  var share = e.target.closest('[data-share]');
  if (share) {
    var url = share.dataset.shareUrl;
    if (navigator.share) {
      navigator.share({ title: share.dataset.shareTitle, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var label = share.textContent;
        share.textContent = 'Copied!';
        setTimeout(function () { share.textContent = label; }, 1500);
      });
    }
    return;
  }

  // info / wall tabs
  var tab = e.target.closest('[data-tab]');
  if (tab) {
    switchTab(tab.closest('.single-content'), tab.dataset.tab);
  }
});

function switchTab(root, name) {
  if (!root) return;
  root.querySelectorAll('[data-tab-pane]').forEach(function (pane) {
    pane.hidden = pane.dataset.tabPane !== name;
  });
  root.querySelectorAll('[data-tab]').forEach(function (btn) {
    btn.classList.toggle('event-tabs__tab--active', btn.dataset.tab === name);
  });
}

// deep link: /club/some-event#wall opens the wall tab directly
function openHashTab() {
  if (location.hash === '#wall') {
    var tabs = document.querySelector('[data-event-tabs]');
    if (tabs) switchTab(tabs.closest('.single-content'), 'wall');
  }
}

document.addEventListener('DOMContentLoaded', openHashTab);
window.addEventListener('hashchange', openHashTab);
